/* Timed-deal badges — opt-in via product metafield custom.deal_until.
   Reveals the badge (hidden in HTML to avoid a flash of an expired deal on
   cached pages), counts down, and hides it once the deal ends. The PRICE is
   Shopify's job (compare_at_price or a scheduled automatic discount whose end
   date matches deal_until) — this only drives the display. */
(function () {
  var isAr = document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0;

  function parseEnd(raw) {
    raw = (raw || '').trim();
    if (!raw) return NaN;
    /* bare local datetimes (no zone) are Morocco wall-clock → pin to +01:00 */
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw = raw.replace(' ', 'T') + '+01:00';
    return Date.parse(raw);
  }
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function fmt(diff) {
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    if (d >= 1) return (isAr ? d + 'ي ' : d + 'j ') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    return pad(h) + ':' + pad(m) + ':' + pad(sec);
  }

  var badges = [];
  function collect() {
    badges = Array.prototype.slice.call(document.querySelectorAll('[data-jy-deal-until]')).map(function (el) {
      return { el: el, end: parseEnd(el.getAttribute('data-jy-deal-until')), clock: el.querySelector('[data-jy-deal-clock]') };
    });
    tick();
  }
  function tick() {
    var now = Date.now();
    var alive = false;
    badges.forEach(function (b) {
      if (!b.el || isNaN(b.end)) {
        if (b.el) b.el.hidden = true;
        return;
      }
      var diff = b.end - now;
      if (diff <= 0) {
        b.el.hidden = true;
        b.el = null;
        return;
      }
      if (b.clock) b.clock.textContent = fmt(diff);
      b.el.hidden = false;
      alive = true;
    });
    if (alive) {
      if (!tick._t) tick._t = setInterval(tick, 1000);
    } else if (tick._t) {
      clearInterval(tick._t);
      tick._t = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
  /* re-scan after AJAX product-grid swaps (infinite scroll / filters) */
  document.addEventListener('jy:cards-updated', collect);

  /* fallback copy for old Android WebViews / non-secure contexts where
     navigator.clipboard is missing — returns true only if the copy stuck */
  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-9999px';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  /* keyboard activation for the role="button" coupon (Enter / Space) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target.closest && e.target.closest('[data-jy-copy]');
    if (!t) return;
    e.preventDefault();
    t.click();
  });

  /* coupon click-to-copy (flash hero) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-jy-copy]');
    if (!el) return;
    var code = el.getAttribute('data-jy-copy') || '';
    var done = function () {
      el.classList.add('is-copied');
      var c = el.querySelector('.jy-flashero__coupon-copy');
      if (c) {
        var prev = c.textContent;
        c.textContent = isAr ? 'تم النسخ ✓' : 'Copié ✓';
        setTimeout(function () {
          c.textContent = prev;
          el.classList.remove('is-copied');
        }, 1600);
      }
    };
    /* only show "Copié ✓" on a real copy — never claim success blindly */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {
        if (legacyCopy(code)) done();
      });
    } else if (legacyCopy(code)) {
      done();
    }
  });
})();
